import { combineReducers } from 'redux';
import types from './types';

//避難所名
const shelterName = (state = '', action) => {
  switch (action.type) {
    case types.SET_SHELTERT_NAME:
      return action.shelterName;
    default:
      return state;
  }
};

//入所時遷移元
const entryKubun = (state = [], action) => {
  switch (action.type) {
    case types.SET_ENTRY_KUBUN:
      return action.entryKubun;
    default:
      return state;
  }
};

const reducer = combineReducers({
  shelterName,
  entryKubun
});
export default reducer;
